export default {"src":"/_next/static/media/class.217f999c.svg","height":14,"width":12,"blurWidth":0,"blurHeight":0};